import { Axios } from "../axios";
import {
  QuoteVerifyInitResponse,
  QuoteVerifyOtpResponse,
  ResendOtpResponse,
  VerifyQuoteType,
} from "../../pages/verify-quote/types";

export const verifyQuoteApi = {
  getVerifyQuote: (id: string, type: VerifyQuoteType) =>
    Axios.get<QuoteVerifyInitResponse>("/remit/user/verifyQuote", { params: { id, type } }),

  verifyQuoteOtp: (id: string, otp: string) =>
    Axios.post<QuoteVerifyOtpResponse>("/remit/user/verifyQuote/otp", { id, otp }),

  resendVerifyQuoteOtp: (id: string) =>
    Axios.post<ResendOtpResponse>("/remit/user/verifyQuote/resendOtp", { id }),
};
